import { render, staticRenderFns } from "./EcommerceTransactions.vue?vue&type=template&id=e55f67a0&scoped=true&"
import script from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
export * from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTransactions.vue?vue&type=style&index=0&id=e55f67a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f67a0",
  null
  
)

export default component.exports